import axios from 'axios';
import { API_BASE_URL, SCP_PATH } from '../../constants';
import qs from 'qs'

const APPLICATION_SERVICE_URL = API_BASE_URL+SCP_PATH+'/application'
//#region APPLICATION
export function getPageApplication(filter, page, size, sortField, sortOrder) {
    const order = sortOrder === 1 ? 'asc' : sortOrder === -1 ? 'desc' : '';
    const sort = sortField ? `${sortField},${order}` : '';
    return axios.get(`${APPLICATION_SERVICE_URL}/page`, {
        params: { ...filter, page, size, sort }
    }).then(res => {return res.data}).catch(error => console.log(error));
}

export function getApplication(id) {
    return axios.get(`${APPLICATION_SERVICE_URL}/${id}`).then(res => {return res.data}).catch(error => console.log(error));
}

export function getApplications(isSimple=true) {
    return axios.get(`${APPLICATION_SERVICE_URL}/list`, {
        params: {isSimple}
    }).then(res => {return res.data}).catch(error => console.log(error));
}

export function saveApplication(data) {
    return axios.post(`${APPLICATION_SERVICE_URL}`, data)
    .then(res => {return res.data}).catch(error => console.log(error));
}

export function deleteApplication(id) {
    return axios.delete(`${APPLICATION_SERVICE_URL}/${id}`)
    .then(res => {return res.data}).catch(error => console.log(error));
}

export function viewLog(participantId, assetScheduleId){
    return axios.get(`${APPLICATION_SERVICE_URL}/log-view`,{params: {participantId,assetScheduleId }}
    ).then(res => res.data).catch(error => console.log(error));
}
//#endregion

//#region APPLICATION RECORD
export function getPageApplicationRecord(filter, page, size, sortField, sortOrder) {
    const order = sortOrder === 1 ? 'asc' : sortOrder === -1 ? 'desc' : '';
    const sort = sortField ? `${sortField},${order}` : '';
    return axios.get(`${APPLICATION_SERVICE_URL}/record/page`, {
        params: { ...filter, page, size, sort },paramsSerializer: params => {return qs.stringify(params)} 
    }).then(res => {return res.data}).catch(error => console.log(error));
}

export function getApplicationRecord(id) {
    return axios.get(`${APPLICATION_SERVICE_URL}/record/${id}`)
    .then(res => {return res.data}).catch(error => console.log(error));
}

export function deleteApplicationRecord(id) {
    return axios.delete(`${APPLICATION_SERVICE_URL}/record/${id}`)
    .then(res => {return res.data}).catch(error => console.log(error));
}

export function updateStatusApplicationRecord(id, status) {
    return axios.post(`${APPLICATION_SERVICE_URL}/record/update-status`, null, {params: {id, status}})
    .then(res => {return res.data}).catch(error => console.log(error));
}

export function answerApplicationRecord(data) {
    return axios.post(`${APPLICATION_SERVICE_URL}/record/answer`, null, {params: {...data}})
    .then(res => {return res.data}).catch(error => console.log(error));
}
//#endregion

